// Dynamically update the header heart icon to filled if wishlist is not empty
(function() {
  function setHeaderHeartFilled(filled) {
    var iconSpan = document.getElementById('wishlist-heart-icon');
    if (!iconSpan) return;
    if (filled) {
      iconSpan.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-heart" viewBox="0 0 24 24" width="22" height="22"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" fill="#e94b3c" stroke="#e94b3c" stroke-width="2"/></svg>`;
    } else {
      iconSpan.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-heart" viewBox="0 0 24 24" width="22" height="22"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" fill="none" stroke="#e94b3c" stroke-width="2"/></svg>`;
    }
  }

  function updateHeaderHeartFromStorage() {
    var favorites = [];
    try {
      favorites = JSON.parse(localStorage.getItem('favorites') || '[]');
    } catch (e) {}
    setHeaderHeartFilled(Array.isArray(favorites) && favorites.length > 0);
  }

  // Listen for favorites updates
  document.addEventListener('favoritesUpdated', updateHeaderHeartFromStorage);
  document.addEventListener('favorites-updated', updateHeaderHeartFromStorage);

  // Initial update on page load
  document.addEventListener('DOMContentLoaded', updateHeaderHeartFromStorage);
  // Also run immediately in case DOMContentLoaded already fired
  updateHeaderHeartFromStorage();
})();
